import {
	ChangeDetectionStrategy,
	Component,
	ElementRef,
	HostBinding,
	OnInit,
	Renderer2,
	ViewEncapsulation,
} from "@angular/core";
import { select, Store } from "@ngrx/store";
import { CoreContentState, Icon, IconSelector } from "@obg/ngx.core.content";
import { CookieService } from "@obg/ngx.global.evo";
import { ignoreEmpty } from "@obg/rxjs";
import { Observable } from "rxjs";

import { RegulatoryBarService } from "../regulatory-bar.service";

import { AAMS_REGULATORY_BAR, AAMS_REGULATORY_BAR_HEIGHT } from "./aams-regulatory-bar.container.const";

@Component({
	selector: "obg-aams-regulatory-bar",
	templateUrl: "./aams-regulatory-bar.container.html",
	styleUrls: ["./aams-regulatory-bar.container.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class AamsRegulatoryBarContainer implements OnInit {
	@HostBinding("class.obg-aams-regulatory-bar") hostCssClass = true;

	readonly regulationIcons$: Observable<Icon[]>;

	private isOpen = true;

	constructor(
		private store: Store<CoreContentState>,
		private iconSelector: IconSelector,
		private cookieService: CookieService,
		private renderer: Renderer2,
		private element: ElementRef,
		private regulatoryBarService: RegulatoryBarService
	) {
		this.regulationIcons$ = this.store.pipe(
			select(this.iconSelector.get(AAMS_REGULATORY_BAR.ICON_NAME)),
			ignoreEmpty()
		);
	}

	ngOnInit() {
		const cookieValue = this.cookieService.get(AAMS_REGULATORY_BAR.CLOSED_COOKIE_NAME);
		this.isOpen = !JSON.parse(cookieValue || "false");
		this.setClosedState();
	}

	onToggleBar() {
		this.isOpen = !this.isOpen;
		this.cookieService.set({ name: AAMS_REGULATORY_BAR.CLOSED_COOKIE_NAME, value: !this.isOpen });
		this.setClosedState();
	}

	private setClosedState() {
		const setClosedStateFunc = (element: any, name: string) =>
			this.isOpen ? this.renderer.removeClass(element, name) : this.renderer.addClass(element, name);
		setClosedStateFunc(this.element.nativeElement, AAMS_REGULATORY_BAR.CLOSED_CLASS_NAME);
		this.regulatoryBarService.setRegulatoryBarDynamicHeight(this.isOpen ? AAMS_REGULATORY_BAR_HEIGHT : 0);
	}
}
